import { create } from "zustand";

export const DEFAULT_SEARCH = {
  jobcategory: "",
  keyword: "",
  city: "",
  zip: "",
  distance: "",
  candidatespeaks: "",
  withinweek: "",
  withinmonth: "",
  tutorintrestedin: "",
  tutorintrestedin1: "",
  tutorintrestedin2: "",
  rates: "",
  tutorperhrrate: "",
  tutorexp: "",
  childneedcareno: "",
  preferredageofprovider: "",
  workingabroad: "",
  childsocialneed: "",
  carorlicence: "",
  backgroundstatus: "",
  nanynewbornexp: "",
};

export const DEFAULT_JOBS = {
  English: "",
  Serbian: "",
  Mathematics: "",
  Physics: "",
  Chemistry: "",
  Online: "",
};

export const useSearchStore = create((set) => ({
  filter: JSON.parse(localStorage.getItem("filter")) || {},
  search: {
    jobcategory: "",
    keyword: "",
    city: "",
    zip: "",
    withinweek: "",
    withinmonth: "",
    tutorintrestedin: "",
    tutorintrestedin1: "",
    tutorintrestedin2: "",
    rates: "",
    tutorperhrrate: "",
    tutorexp: "",
    childneedcareno: "",
    preferredageofprovider: "",
    workingabroad: "",
    childsocialneed: "",
    distance: "",
    carorlicence: "",
    backgroundstatus: "",
    nanynewbornexp: "",
    candidatespeaks: "",
  },
  languageSpeak: {
    English: "",
    Serbian: "",
    Mathematics: "",
    Physics: "",
    Chemistry: "",
    Online: "",
  },
  setFilter: (newFilter) =>
    set((state) => ({ filter: { ...state.filter, ...newFilter } })),
  setSearch: (newSearch) =>
    set((state) => ({ search: { ...state.search, ...newSearch } })),
  setLanguageSpeak: (newLanguageSpeak) =>
    set((state) => ({
      languageSpeak: { ...state.languageSpeak, ...newLanguageSpeak },
    })),
}));
